<div class="row page-header">
    <div class="col-12">
        <h1>Delivery Lookahead <small>(Beta) Next 3 weeks</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <div class="row action-toolbar mb-3">
        <div class="col-12">
            <form class="form-inline">
                <div class="form-group me-3 mb-2">
                    <label class="me-2" for="fabDeliveryJobSelect">Job</label>
                    <wj-combo-box
                        id="fabDeliveryJobSelect"
                        name="fabDeliveryJobSelect"
                        [(ngModel)]="selectedJobId"
                        [itemsSource]="jobOptions"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                        (selectedIndexChanged)="onJobChanged()"
                        style="width: 22rem"
                    ></wj-combo-box>
                </div>
            </form>
        </div>
    </div>

    <div class="row g-3 mb-4">
        @for (week of weeks; track week.weekNumber) {
            <div class="col-12 col-lg-4">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-start mb-2">
                            <div>
                                <h2 class="h5 mb-0">{{ week.label }}</h2>
                                <small class="text-muted">{{ formatDate(week.weekStart) }} – {{ formatDate(week.weekEnd) }}</small>
                            </div>
                            <div class="text-end">
                                <span class="badge bg-primary">{{ week.pieces.length }}</span>
                                @if (atRiskCount(week) > 0) {
                                    <span class="badge bg-danger ms-1">{{ atRiskCount(week) }} at risk</span>
                                }
                            </div>
                        </div>
                        @if (week.pieces.length === 0) {
                            <p class="text-muted mb-0">No expected deliveries.</p>
                        } @else {
                            <ul class="list-group list-group-flush">
                                @for (piece of week.pieces; track piece.id) {
                                    <li class="list-group-item px-0 border-start border-3 ps-2" [class]="riskClass(piece)">
                                        <div class="fw-semibold">
                                            {{ piece.markCode || piece.name }}
                                            @if (piece.isOnHold) {
                                                <span class="badge bg-warning text-dark ms-1">Hold</span>
                                            }
                                            @if (piece.riskLevel === 'AtRisk') {
                                                <span class="badge bg-danger ms-1">At risk</span>
                                            }
                                        </div>
                                        <div class="small">{{ piece.name }}</div>
                                        <div class="small text-muted">
                                            {{ piece.scope }} · due {{ formatDate(piece.effectiveRequiredOnSiteDate) }}
                                        </div>
                                    </li>
                                }
                            </ul>
                        }
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="row">
        <div class="col-12">
            <h4>Recently Delivered (last 14 days)</h4>
            @if (recentlyDelivered.length === 0) {
                <p class="text-muted">No recent deliveries.</p>
            } @else {
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th>DWG #</th>
                                <th>Name</th>
                                <th>Scope</th>
                                <th>Current Step</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (piece of recentlyDelivered; track piece.id) {
                                <tr>
                                    <td>{{ piece.markCode || '—' }}</td>
                                    <td>{{ piece.name }}</td>
                                    <td>{{ piece.scope }}</td>
                                    <td>{{ piece.currentStepName }}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }
        </div>
    </div>
</div>
